
import { Component, Vue, Watch } from "vue-property-decorator";
import ProjectsRepository from "../repositories/implementations/ProjectsRepository";
import ProjectLanguagesRepository from "../repositories/implementations/ProjectLanguagesRepository";
import StatsRepository, { ProjectStats } from "../repositories/implementations/StatsRepository";
import { Project } from "../entities/Project";
import { ProjectLanguage } from "../entities/ProjectLanguage";
import { toastError } from "../utils/toast";
import SearchResultsView from "./project-detail/SearchResultsView.vue";

@Component({
  components: { SearchResultsView },
})
export default class ProjectDetailView extends Vue {
  project: Project | null = null;

  languages: ProjectLanguage[] = [];

  stats: ProjectStats | null = null;

  loadingProject = true;

  activeTab = 0;

  searchQuery = "";

  searchActive = false;

  projectsRepo = new ProjectsRepository();

  langRepo = new ProjectLanguagesRepository();

  statsRepo = new StatsRepository();

  get projectId(): string {
    return this.$route.params.projectId;
  }

  get isTranslationByLanguageView(): boolean {
    return this.$route.name === "project-translations-by-language";
  }

  get totalTerms(): number {
    return this.stats?.termCount ?? 0;
  }

  get totalTranslations(): number {
    return this.stats?.totalCompleted ?? 0;
  }

  get overallPercent(): number {
    return this.stats?.overallPercent ?? 0;
  }

  async created() {
    await this.loadAll();
  }

  @Watch("projectId")
  async onProjectIdChanged() {
    await this.loadAll();
  }

  async loadAll() {
    this.loadingProject = true;
    try {
      const [proj, langs] = await Promise.all([this.projectsRepo.getById(this.projectId), this.langRepo.getByProject(this.projectId)]);

      if (!proj) {
        this.project = null;
        return;
      }

      this.project = proj;
      this.languages = langs;

      await this.loadStatsData();
    } catch (e: any) {
      toastError("Failed to load project.");
    } finally {
      this.loadingProject = false;
    }
  }

  async loadStatsData() {
    this.stats = await this.statsRepo.getProjectStats(this.projectId);
  }

  async reloadStats() {
    await this.loadStatsData();
  }

  async reloadLanguagesAndStats() {
    const [langs] = await Promise.all([this.langRepo.getByProject(this.projectId)]);
    this.languages = langs;
    await this.loadStatsData();
  }

  runSearch() {
    if (this.searchQuery.trim()) {
      this.searchActive = true;
    }
  }

  clearSearch() {
    this.searchActive = false;
    this.searchQuery = "";
  }
}
